import { Component, type OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, type Params, Router, RouterModule } from '@angular/router'
import {
  type User, UserService
} from '@inside-hub-app/customer-portal-b2c-client'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { KeycloakService } from '@emilfreydigital/keycloak-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { TranslateService } from '@ngx-translate/core'
import { take } from 'rxjs'
import { type ParsedToken } from '../../../../models/keycloak'
import { DataService } from '../../../services/data.service'
import { SharedService, type Tab } from '../../../services/shared.service'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { FooterContainerComponent } from '../../../components/basic/footer-container/footer-container.component'
import { MyAccountHeadComponent } from '../../../components/revolution/general-user-data/my-account-head/my-account-head.component'
import { RevolutionMyVehicleNavigationComponent } from '../../../components/revolution/general-user-data/my-account-navigation/my-account-navigation.component'
import { NavbarComponent } from '../../../components/revolution/navigation/navbar/navbar.component'
import { NavbarSecondComponent } from '../../../components/revolution/navigation/navbar-second/navbar-second.component'
@Component({
  selector: 'customer-portal-app-revolution-details-view',
  standalone: true,
  templateUrl: './details-view.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    FooterContainerComponent,
    MyAccountHeadComponent,
    RevolutionMyVehicleNavigationComponent,
    NavbarComponent,
    NavbarSecondComponent
  ]
})
export class RevolutionDetailsViewComponent implements OnInit {
  private urlParams: Params

  constructor (
    private readonly keycloak: KeycloakService,
    private readonly userService: UserService,
    private readonly translateService: TranslateService,
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly dataService: DataService,
    private readonly route: ActivatedRoute,
    private readonly sharedService: SharedService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    route.params.subscribe(params => {
      this.urlParams = params
      this.switchRoute(this.urlParams)
    })
    this.hasNewFooter = this.remoteConfigService.get('hasNewFooter')
  }

  token: ParsedToken
  user: User
  loading = true
  currentTab: Tab
  public hasNewFooter
  translateLoaded: boolean

  ngOnInit (): void {
    this.token = this.keycloak.getKeycloakInstance().tokenParsed as ParsedToken
    this.translateService.onDefaultLangChange
      .pipe(take(1))
      .subscribe(() => (this.translateLoaded = true))
    this.load()
  }

  load (): void {
    this.loading = true
    this.dataService.onUserLoaded.subscribe(user => {
      this.user = user
      this.loading = false
      if (user != null) {
        if (
          this.sharedService.stringExists(this.user.profilePictureUrl) &&
          this.user.profilePictureUrl != null
        ) {
          this.user.profilePictureUrl = `${
            this.user.profilePictureUrl
          }${this.remoteConfigService.get(
            'b2c.apiKey'
          )}&ts=${new Date().getTime()}`
        }
      }
    })
  }

  switchRoute (urlParams: Params): void {
    if (this.sharedService.stringExists(urlParams.detailsSubmenu)) {
      const param = this.urlParams.detailsSubmenu
      switch (param) {
        case 'dataprotection':
          this.currentTab = 'dataprotection'
          break
        case 'userDetails':
          this.currentTab = 'userDetails'
          break
        case 'userPersonalization':
          this.currentTab = 'userPersonalization'
          break
        case 'userCommunication':
          this.currentTab = 'userCommunication'
          break
        case 'userNotifications':
          this.currentTab = 'userNotifications'
          break
      }
    }
  }
}
